import React, { useState, useContext } from 'react';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Button } from 'react-bootstrap';
import Layout from 'components/sales/layout/layout';
import ModalPop from 'components/sales/modal/modal';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import { Link, useParams } from 'react-router-dom';
import FormSection from 'components/sales/formSection/formSectionNew';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import Regex from 'services/utils/regex/Regex';
import DatePicker from 'components/sales/datePicker/datePicker';

const MakePayment = ({ addPayment, match }) => {
  const { id } = useParams();
  const { baseUrl } = useContext(BaseUrl);
  const [isFiled, setIsFiled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const inputs = {
    received_amount: '',
    received_date: '',
    payment_mode: '',
    tds_deducted: '',
    retention_amount: '',
    payment_utr: '',
    remarks: '',
    payable_amount: '',
    invoice_id: id,
  };
  const [formData, setData] = useState(inputs);
  const [isModal, setIsModal] = useState(false);

  const onSubmit = async () => {
    if (
      formData.received_amount !== '' &&
      formData.received_date !== '' &&
      formData.payment_mode !== '' &&
      formData.tds_deducted !== ''
    ) {
      setIsFiled(false);
      setIsLoading(true);
      const res = addPayment(formData);
      if (res) {
        setIsModal(true);
      }
      setIsLoading(false);
    } else {
      setIsFiled(true);
    }
  };

  const headerBtns = () => {
    return (
      <Button
        onClick={() => {
          onSubmit();
        }}
        className="btn btn-primary"
      >
        {localization.submitDtl}
        <img src={Images?.ArrowRight} alt="" />
      </Button>
    );
  };

  return (
    <Layout
      title={localization.makePayment}
      Buttons={headerBtns}
      className={isFiled && 'requiredFileds'}
      isGoback
      isLoading={isLoading}
      linkUrl={`${baseUrl}/brand-activation/invoice/view-details/${id}`}
    >
      <FormSection title={localization.formDetails}>
        <ConstantInput
          value={formData?.received_amount}
          label={localization.receivedAmount}
          regex={Regex.numeric.test(formData.received_amount)}
          type="text"
          errorMsg={localization.isRequired}
          handleChange={(value) =>
            setData({ ...formData, received_amount: value })
          }
          required
          isStarRequired={true}
        />

        <DatePicker
          handleChange={(val) => {
            setData({ ...formData, received_date: val });
          }}
          value={formData?.received_date && new Date(formData?.received_date)}
          label={localization.receivedDate}
          // minimumDate={new Date()}
        />
        <DropDownInput
          data={[
            { id: 1, name: 'Cash' },
            { id: 2, name: 'Cheque' },
            { id: 3, name: 'NEFT' },
            { id: 4, name: 'IMPS' },
            { id: 5, name: 'RTGS' },
          ]}
          label={localization.paymentMode}
          required
          isStarRequired={true}
          errorMsg={localization.isRequired}
          getIdValue={(val) =>
            setData({
              ...formData,
              payment_mode: val.id,
            })
          }
        />
        <ConstantInput
          label={localization.tdsDeducted}
          regex={Regex.numeric.test(formData.tds_deducted)}
          errorMsg={localization.isRequired}
          type="text"
          required
          isStarRequired={true}
          handleChange={(value) =>
            setData({ ...formData, tds_deducted: value })
          }
        />

        <ConstantInput
          label={localization.retentionAmount}
          regex={Regex.numeric.test(formData.retention_amount)}
          errorMsg={localization.isRequired}
          type="number"
          required
          isStarRequired={true}
          handleChange={(value) =>
            setData({ ...formData, retention_amount: value })
          }
        />

        <ConstantInput
          label={localization.paymentUtr}
          regex={Regex.alphaNum.test(formData.payment_utr)}
          errorMsg={localization.isRequired}
          type="text"
          required
          isStarRequired={true}
          handleChange={(value) => setData({ ...formData, payment_utr: value })}
        />

        <ConstantInput
          label={localization.remarks}
          regex={Regex.alphaNum.test(formData.remarks)}
          errorMsg={localization.isRequired}
          type="text"
          required
          isStarRequired={true}
          handleChange={(value) => setData({ ...formData, remarks: value })}
        />

        <ConstantInput
          label={localization.payableAmount}
          regex={Regex.numeric.test(formData.payable_amount)}
          errorMsg={localization.isRequired}
          type="number"
          required
          isStarRequired={true}
          handleChange={(value) =>
            setData({ ...formData, payable_amount: value })
          }
        />
      </FormSection>
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={() => {
          setIsModal(false);
        }}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.addedSuccessfully}</h5>
          <Link
            to={`/dashboard/brand-activation/invoice/view-details/${id}`}
            className="btn btn-primary mb-4"
          >
            {localization.continue} <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
    </Layout>
  );
};

MakePayment.propTypes = {};

export default MakePayment;
